import React from 'react';
const bonuses = [{
  title: '🎁 BONUS 1 — Dossiers Patients Professionnels™',
  description: "Des modèles prêts à utiliser pour réaliser vos bilans, suivre l'évolution de vos patients, fixer les objectifs thérapeutiques et organiser vos dossiers plus efficacement."
}, {
  title: "🎁 BONUS 2 — 100 Fiches d'Exercices à Domicile™",
  description: "100 fiches prêtes à remettre à vos patients avec les exercices, les répétitions, les conseils d'exécution et les progressions pour améliorer leur suivi entre les consultations."
}, {
  title: '🎁 BONUS 3 — Protocoles de Rééducation Complets™',
  description: 'Une collection de protocoles organisés pour les principales pathologies, avec des progressions claires, des objectifs et des critères de réévaluation.'
}, {
  title: '🎁 BONUS 4 — Check-lists et Outils Cliniques™',
  description: 'Des check-lists professionnelles, grilles de suivi et documents pratiques pour standardiser vos consultations et gagner du temps au quotidien.'
}, {
  title: "🎁 BONUS 5 — 52 Plans de Séances Prêts à l'Emploi™",
  description: "Une année complète de séances déjà préparées pour vous aider à organiser rapidement vos consultations tout au long de l'année."
}];
export function BonusSection() {
  return <section className="bg-brand-ivory px-4 py-5 sm:px-6" data-id="element-24" data-mp="2jiehpx9lnkxd">
      <div className="mb-3 text-center" data-id="element-25" data-mp="2ohit8ujzxuqv">
        <h2 className="text-3xl font-black uppercase leading-none" data-id="element-26" data-mp="2og7n4o32wawl">🎁 5 BONUS PREMIUM INCLUS</h2>
        <p className="mt-1 text-sm font-medium leading-snug" data-id="element-27" data-mp="1qus6q3y1le0h">En plus de KINÉ READY™, vous recevrez 5 Bonus Premium conçus pour vous faire gagner encore plus de temps et simplifier votre pratique quotidienne.</p>
      </div>
      <div className="flex flex-col gap-2" data-id="element-28" data-mp="20trfdmit59nh">
        {bonuses.map(bonus => <article key={bonus.title} className="rounded-md border-2 border-brand-gold/60 bg-white p-3 text-center shadow-sm" data-id="element-29" data-mp="25rsyg7g8h8yy">
            <h3 className="mb-1 font-body text-sm font-extrabold uppercase leading-tight text-brand-navy" data-id="element-30" data-mp="3h5myjeyno5t1">{bonus.title}</h3>
            <p className="text-sm font-medium leading-snug" data-id="element-31" data-mp="1h2vrish8hl14">{bonus.description}</p>
          </article>)}
      </div>
    </section>;
}